import { useLocalSearchParams } from 'expo-router';
import { ErrorBoundary } from '../../../components/layout';
import { AcceptInvitationScreen } from '../../../components/invite/AcceptInvitationScreen/AcceptInvitationScreen';

export default function AcceptInvitationRoute() {
  const { token } = useLocalSearchParams<{ token: string }>();
  return (
    <ErrorBoundary>
      <AcceptInvitationScreen token={token} />
    </ErrorBoundary>
  );
}
